import {
    LOAD_CUSTOMER_INSIGHT,
    LOAD_CUSTOMER_INSIGHT_DISABLED
} from "../../../actions/types";

const INITIAL_STATE = {

    customerName: "",
    customerPhone: "",
    customerEmail: "",
    customerStatus: "",
    orderCount: 0,
    lifetimeValue: 0,
    averageSpent: 0,
    frequencyDays: 0,
    firstOrderDate: "",
    lastOrderDate: "",
    customerAddresses: [],
    paymentTypeSummaries: [],
    sourceTypeSummaries: [],
    orderTypeSummaries: [],
    promotionSummaries: [],
    productSummaries: [],
    ordersByHourSummaries: [],
    ordersByDaySummaries: [],
    customerTimeline: [],
    vip: false,
    insightEnabled: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CUSTOMER_INSIGHT:
            return {
                customerName: action.payload.customerName,
                customerPhone: action.payload.customerPhone,
                customerEmail: action.payload.customerEmail,
                customerStatus: action.payload.customerStatus,
                orderCount: action.payload.orderCount,
                lifetimeValue: action.payload.lifetimeValue,
                averageSpent: action.payload.averageSpent,
                frequencyDays: action.payload.frequencyDays,
                firstOrderDate: action.payload.firstOrderDate,
                lastOrderDate: action.payload.lastOrderDate,
                customerAddresses: action.payload.customerAddresses,
                paymentTypeSummaries: action.payload.paymentTypeSummaries,
                sourceTypeSummaries: action.payload.sourceTypeSummaries,
                orderTypeSummaries: action.payload.orderTypeSummaries,
                promotionSummaries: action.payload.promotionSummaries,
                productSummaries: action.payload.productSummaries,
                ordersByHourSummaries: action.payload.ordersByHourSummaries,
                ordersByDaySummaries: action.payload.ordersByDaySummaries,
                customerTimeline: action.payload.customerTimeline,
                vip: action.payload.vip,
                insightEnabled: true
            };
        case LOAD_CUSTOMER_INSIGHT_DISABLED:
            return {
                ...state,
                insightEnabled: false
            }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/restaurants/customerInsight/CustomerInsightReducer.js